import type { IconData } from '@stacksjs/iconify-core'

export const earth1Solid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 47.5C11.021 47.5.5 36.979.5 24S11.021.5 24 .5S47.5 11.021 47.5 24S36.979 47.5 24 47.5m3.187-35.009a158 158 0 0 1 9.13-2.294A18.45 18.45 0 0 1 42.5 24a18.43 18.43 0 0 1-4.375 11.948c-3.083-3.365-5.547-8.036-6.614-10.22a2.52 2.52 0 0 0-1.603-1.337l-2.412-.64C24.7 23.01 22.17 20.683 22.72 17.6c.109-.61.274-1.247.518-1.892c.655-1.735 2.293-2.748 3.949-3.216M18.84 35.695a37.5 37.5 0 0 1-1.842 5.434c-6.251-2.558-10.791-8.438-11.423-15.446c2.763.016 5.088.26 6.013.372c.31.037.63.101.945.217c3.362 1.233 5.264 4.637 6.08 6.47c.419.94.474 1.976.227 2.953\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default earth1Solid
